import React, { useEffect } from "react";
import styled from "styled-components";
import { useInput } from "hooks";
import { DropDown2 } from "components";

export const OfferPurchaseCaseTextBuilder = ({
  className,
  value,
  onChange = () => { },
}) => {
  const withCase = useInput("");
  const withCaseType = [
    { id: "", title: "" },
    { id: "whole", title: "whole" },
    { id: "half", title: "half" }
  ]

  const handleUpdateValue = (withCas) => {
    onChange(`w/purchase/${withCas ? `${withCas} ` : ""}case`);
  };

  useEffect(() => {
    if (value && value.startsWith("w/purchase/")) {
      // check if withCaseType is in the text
      const foundType = withCaseType.find(
        (type) => type.id && value.includes(type.id)
      );
      withCase.setValue(foundType ? foundType.id : "");
    }
    return () => { };
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>

      <Container className="mt-2">
        <Label>w/purchase</Label>
        <DropDown2
          data={withCaseType}
          width={100}
          value={withCase.value}
          onChange={(e) => {
            withCase.setValue(e);
            handleUpdateValue(e);
          }}
        />
        <Label>case</Label>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
const Label = styled.div`
  font-size: 14px;
  line-height: 32px;
  white-space: nowrap;
`;
